import React, { FC, ReactNode } from "react";
import classNames from "classnames";

import Icon from "../Icon";

type ValueType = string | undefined;

export interface OptionType {
  icon?: string;
  value: ValueType;
  label: string | ReactNode;
}

type Props = {
  name: string;
  options: OptionType[];
  onChange: (selected: ValueType) => void;
  value: ValueType;
  className?: string;
  dataTest?: string;
};

export const MultiToggle: FC<Props> = ({
  name,
  options,
  value: selected,
  onChange,
  className,
  dataTest,
}) => {
  return (
    <div
      className={classNames(
        "flex font-manrope text-base font-semibold",
        className
      )}
      data-test={dataTest}
    >
      {options.map(({ label, value, icon }, index) => (
        <div
          className={classNames(
            "flex gap-1 py-3 px-3 rounded-lg border-purple-500 cursor-pointer",
            {
              "border bg-purple-50 font-extrabold": selected === value,
            }
          )}
          key={`${name}-option-${index}`}
          onClick={() => onChange(value)}
          data-selected={selected === value}
          data-test={`${dataTest}-${value}`}
        >
          {icon && <Icon icon={icon} size={24} />}
          {label}
        </div>
      ))}
    </div>
  );
};
